import { gql } from "@apollo/client";

export default gql`
  mutation updateAccountOnboardingMutation($accountSetupData: JSONString!) {
    updateAccountOnboarding(accountSetupData: $accountSetupData) {
      user {
        id
        onboardingData
      }
    }
  }
`;
